const axios = require('axios');

const checkMerchantStauts = async (url) => {
    const apiUrl = window.spconfig?.config.apiUrl;
    const urlLink = apiUrl + "/growapi/checkstatus";
    const data = {
        urltoken: url,
    };
    return await axios.post(urlLink, JSON.stringify(data), {
        headers: { "Content-Type": "application/json" },
    })
        .then((response) => {
            return response;
        },
            (error) => {
                return error;
            })
}


export default checkMerchantStauts;